import { Box } from '@mui/material';
import classes from './telegram-btn.module.sass';
import { useTranslation } from 'react-i18next';
import TelegramIcon from '@/app/assets/icons/tg.svg';

export const TelegramBtn = () => {
  const { t } = useTranslation();

  return (
    <Box
      component='a'
      href='https://t.me/+TKWI9hYQ3uxiMDli'
      className={classes['telegram-btn']}
      target='_blank'
      rel='noopener noreferrer'
    >
      <Box component='span' className={classes['telegram-btn__text']}>
        {t('contact_us')}
      </Box>
      <img
        src={TelegramIcon}
        className={classes['telegram-btn__icon']}
        alt=''
      />
    </Box>
  );
};
